import InfiniteScroll from 'react-infinite-scroll-component';
import {useCategoryProducts} from '../../../../../hooks';
import CategoryItem from './CategoryItem';
import ProductList from './ProductList';

const CategoryList = ({data, handleCategory, fetchMoreData, hasMoreCategory}) => {
    // const {products} = useCategoryProducts(category, setNumOfPages, currentPage, search);

    return (
        <>
            <InfiniteScroll
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(137px, 1fr))',
                    gap: '10px',
                }}
                // className="infiniteScrollBar"
                dataLength={data.length}
                next={fetchMoreData}
                hasMore={hasMoreCategory}
                loader={<h4>Loading...</h4>}
                scrollableTarget="scrollableItemsWrapper">
                {data.map((category, index) => (
                    <CategoryItem category={category} key={index} onPress={handleCategory} />
                ))}
            </InfiniteScroll>
        </>
    );
};

export default CategoryList;
